import { render } from "./ManageDocuments.vue?vue&type=template&id=c3c538c2"
import script from "./ManageDocuments.vue?vue&type=script&lang=js"
export * from "./ManageDocuments.vue?vue&type=script&lang=js"

import "./ManageDocuments.vue?vue&type=style&index=0&id=c3c538c2&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__